import Stack from '@/components/Custom/ModalStack';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateChatChatIdInfoLayoutRoute() {
  return <Stack />;
}
